module.exports = __webpack_public_path__ + "img/ETCRechargePayment.2abdcded.svg";